import { Box } from '@material-ui/core';
import { Currency, formatMoney } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface TotalLineProps {
  label: string;
  value: number;
  currency: Currency;
  labelSuffix?: string | JSX.Element;
  strong?: boolean;
  strikethrough?: boolean;
}

export const TotalLine = ({ label, labelSuffix, value, strong = false, currency, strikethrough }: TotalLineProps) => {
  const labelText = labelSuffix ? (
    <>
      <Text tId={label} />
      {labelSuffix}
    </>
  ) : (
    <Text tId={label} />
  );

  const valueText = formatMoney({ value, currency }, 2);

  return (
    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
      <Font variant={'body2'} strikethrough={strikethrough}>
        <>{strong ? <strong>{labelText}</strong> : labelText}</>
      </Font>
      <Font variant={'body2'} strikethrough={strikethrough}>
        {strong ? <strong>{valueText}</strong> : valueText}
      </Font>
    </Box>
  );
};
